import { Component, input, output, signal } from '@angular/core';

import { AiScreeningResult, AiScreeningResultStatus } from '@core/ai-screening-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent, IconName } from '@core/user-interface-legacy';
@Component({
  selector: 'rt-ai-screening-results-list',
  imports: [ButtonComponent, IconComponent, TranslatePipe],
  templateUrl: './ai-screening-results-list.component.html',
  styleUrl: './ai-screening-results-list.component.less',
})
export class AiScreeningResultsListComponent {
  public screening = input.required<{
    results: AiScreeningResult[];
  }>();
  public disableEdit = input(false);
  public expandable = input(false);

  public edit = output<AiScreeningResult>();

  protected expandedMap = signal<Record<string, boolean>>({});
  protected statusIconMap: Record<AiScreeningResultStatus, IconName> = {
    fulfilled: 'check',
    unfulfilled: 'close',
    unverifiable: 'help-plain',
  };

  protected toggleExpand(id: string | number) {
    this.expandedMap.update(v => ({ ...v, [id]: !v[id] }));
  }
}
